module.exports = __webpack_public_path__ + "img/logo.2f836fe2.png";